import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';

import { MapService } from '../../service/map.service';
import { ConfigService }  from '../../service/config.service';
import { StateService }   from '../../service/state.service';
import {
	FilterConfig,
	MapFilter
} from '../../model';

@Component({
  selector:			'electra-filter',
  styleUrls:		['./filter.component.scss'],
  templateUrl:	'./filter.component.html'
})
export class FilterComponent {  
	config: FilterConfig;
	filter: MapFilter[];

  slideTop = 0;

  @Output() update	= new EventEmitter<number>();

  constructor(public mapService: MapService, public configService: ConfigService, public stateService: StateService) {
		configService.filter.subscribe(data => { this.gotConfig(data) });
		mapService.filter.subscribe(data => { this.gotFilter(data) });
  }

  closeClick() {
    setTimeout( () => {
        this.stateService.state = 'map';
   }, 5);
  }

	getEntryStyle(i: number): any {
		return this.configService.mobile ? {
			height:	(136 / this.config.rows) + 'px',
			left:		(Math.floor(i / this.config.rows) * 160) + 'px',
			top:		(i % this.config.rows * (136 / this.config.rows)) + 'px'
		} : {
			height:	(136 / this.config.rows) + 'px',
			left:		'0',
			top:		(i * (136 / this.config.rows)) + 'px'
		};
	}

	gotConfig(config: FilterConfig) {
		this.config = config;
	}

	gotFilter(filter: MapFilter[]) {
		this.filter = filter;
  }

  updateY(event: number) {
    if (event < 1) {
    	this.slideTop = event * -1;
    } else {
      this.slideTop = 0;
    }
  	this.update.next(this.slideTop);
  }

  get deviceType(): string {
    if (this.configService.desktopClass) {
      return 'desktop';
    } else if (this.configService.mobile) {
      return 'mobile';
    }
	}
	
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/filter/filter.component.ts